const videoModalIframeSelector = '.videoModalIframe, .video-modal-iframe';
const videoTriggerSelector = 'a.video, button.video';
const removeWwwPrefix = (hostname) => hostname.replace(/^www\./, '');
const getFirstPathSegment = (pathname) => pathname.split('/').find(Boolean) || '';
const getLastPathSegment = (pathname) => pathname.split('/').filter(Boolean).at(-1) || '';

const getYouTubeEmbedUrl = (url) => {
    const host = removeWwwPrefix(url.hostname);

    if (host === 'youtu.be') {
        const videoId = getFirstPathSegment(url.pathname);
        return videoId ? `https://www.youtube.com/embed/${videoId}` : '';
    }

    if (host === 'youtube.com' || host === 'm.youtube.com') {
        const videoId = url.searchParams.get('v');
        if (videoId) {
            return `https://www.youtube.com/embed/${videoId}`;
        }

        const pathParts = url.pathname.split('/').filter(Boolean);
        const isEmbedOrShortsUrl = pathParts[0] === 'embed' || pathParts[0] === 'shorts';

        if (isEmbedOrShortsUrl) {
            return pathParts[1] ? `https://www.youtube.com/embed/${pathParts[1]}` : '';
        }
    }

    return '';
};

const getVimeoEmbedUrl = (url) => {
    const videoId = getLastPathSegment(url.pathname);
    return videoId ? `https://player.vimeo.com/video/${videoId}` : '';
};

const getEmbedUrl = (rawUrl) => {
    if (!rawUrl) {
        return '';
    }

    try {
        const url = new URL(rawUrl, window.location.href);
        const host = removeWwwPrefix(url.hostname);
        if (host === 'youtu.be' || host === 'youtube.com' || host === 'm.youtube.com') {
            return getYouTubeEmbedUrl(url) || rawUrl;
        }

        if (host === 'vimeo.com' || host === 'player.vimeo.com') {
            return getVimeoEmbedUrl(url) || rawUrl;
        }
    } catch {
        return rawUrl;
    }

    return rawUrl;
};

const withAutoplay = (url) => {
    if (!url) {
        return '';
    }

    if (url.includes('autoplay=1')) {
        return url;
    }

    return url.includes('?') ? `${url}&autoplay=1` : `${url}?autoplay=1`;
};

export const initVideoPopup = () => {

    document.querySelectorAll(videoModalIframeSelector).forEach((iframe) => {
        iframe.hidden = true;
    });

    document.querySelectorAll(videoTriggerSelector).forEach((trigger) => {

        trigger.addEventListener('click', (event) => {
            const container = trigger.parentElement;
            const iframe = container?.querySelector(videoModalIframeSelector);
            console.log('trigger:', trigger);
            console.log('container:', container);
            console.log('iframe found:', iframe);

            if (!iframe) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();
            const rawUrl = trigger.dataset.videoSrc || trigger.dataset.href || trigger.getAttribute('href');

            if (!rawUrl) {
                return;
            }

            const videoTitle = container?.querySelector('.video-title')?.textContent?.trim() || '';
            const embedUrl = getEmbedUrl(rawUrl);

            if (!embedUrl) {
                return;
            }

            trigger.hidden = true;
            trigger.classList.add('d-none');
            iframe.hidden = false;
            window.dataLayer = window.dataLayer || [];

            window.dataLayer.push({
                event: 'video_popup_opened',
                video_url: embedUrl,
                video_title: videoTitle
            });

            iframe.style.opacity = '0';
            iframe.style.transition = 'opacity 80ms ease';
            iframe.setAttribute('src', withAutoplay(embedUrl));
            iframe.addEventListener('load', () => {iframe.style.opacity = '1';},{ once: true }

            );

        });

    });

};